export default [
  { name: 'name', enabled: true },
  { name: 'time', enabled: true },
  { name: 'date', enabled: true },
  { name: 'goodsCollected', enabled: true },
];
